import { IOffer } from '../../fragments/OfferCardWidget/shared/types/offer';

export const isRosreestrCheckedLabelAvailable = (offer: IOffer): boolean => {
  return Boolean(offer.isRosreestrChecked);
};
